import createIsClient from "@repo/signals/createIsClient";
import UType from "@repo/utils/UType";
import AppRouter from "@repo/utils-solid/AppRouter";

declare global {
  interface Window {
    NativeDispatch?: {
      postMessage(body: string): void;
    };
    NativePageIsRoot?: boolean;
  }
}

const isClient = createIsClient();

export const isWebview = () => isClient() && !!window.NativeDispatch;
export const isRootWebview = () =>
  isClient() && window.NativePageIsRoot === true;

type NativeEvents = {
  close:
    | {
        continueWithUrl?: string;
      }
    | undefined;
};

let closeCalled = false;

export function nativeDispatch<EventName extends keyof NativeEvents>(
  event: EventName,
  ...[payload]: UType.DistributeCondition<
    NativeEvents[EventName],
    undefined,
    [undefined?],
    [payload: Exclude<NativeEvents[EventName], undefined>]
  >
) {
  if (!isWebview()) return false;

  if (event === "close") {
    if (isRootWebview()) {
      AppRouter.back();
      return;
    }
    if (closeCalled) return;
    closeCalled = true;
  }

  window.NativeDispatch?.postMessage(
    JSON.stringify({ eventName: event, payload })
  );

  return true;
}
